import React from "react";
import { useState } from "react";
import activeCard from "../../assets/images/card-active.svg";
import ACH from "../../assets/images/ACH.svg";
import billMyAccount from "../../assets/images/bill-my-account.svg";
import inactiveCard from "../../assets/images/card-inactive.svg";
import ACHActive from "../../assets/images/ACH-active.svg";
import billMyAccountActive from "../../assets/images/bill-my-account-active.svg";
import VISA from "../../assets/images/VISA.svg";
import masterCard from "../../assets/images/Mastercard.svg";
import americanExpress from "../../assets/images/american-express.svg";
import { useEffect } from "react";
import AddCardModal from "./AddCardModal";
const PaymentInformation = ({
  creditCardsList,
  billMyAccountData,
  achAccountList,
  cardSequence,
  setCardSequence,
  currentTab,
  setCurrentTab,
  setCreditCardsList,
  setAchData,
  addNewCartData,
  setAddNewCartData,
  addNewACHAccountData,
  setAddNewACHAccountData,
  cardBrandName,
  setCardBrandName,
  setAddAchSeq,
  errorMsg,
  setErrorMsg,
  errorMsgPlaceOrder,
  setErrorMsgPlaceOrder,
  creditCardRules,
  achRules,
  currentFileRequired,
  translationKey,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [accountSequence, setAccountSequence] = useState("");
  const [stripeCustomerId, setStripeCustomerId] = useState("");
  const [currentCardNumber, setCurrentCardNumber] = useState(null);
  const [currentAccNumber, setCurrentAccNumber] = useState(null);
  const canAddNewCard = !!(
    creditCardRules &&
    creditCardRules.enabled &&
    creditCardRules.newAllowed
  );
  const canAddNewACH = !!(achRules && achRules.enabled && achRules.newAllowed);
  const isCardEnabled = !!(creditCardRules && creditCardRules.enabled);
  const isACHEnabled = !!(achRules && achRules.enabled);
  const firstBillMyAccount = billMyAccountData?.[0] || {};

  const safeString = (value) => (typeof value === "string" ? value.trim() : "");
  const last4 = (value) => safeString(value).slice(-4);
  const hasDefaultPaymentMethod = last4(firstBillMyAccount?.cardNumber).length > 0;

  useEffect(() => {
    if (creditCardsList.length) {
      const cardData = creditCardsList.find(
        (card) => safeString(card?.stripeCustomerId).length > 1
      );
      if (cardData) {
        setStripeCustomerId(safeString(cardData?.stripeCustomerId));
      }
    }

    if (!stripeCustomerId && billMyAccountData.length) {
      const fallbackCustomerId = safeString(firstBillMyAccount?.stripeCustomerId);
      if (fallbackCustomerId) {
        setStripeCustomerId(fallbackCustomerId);
      }
    }

    if (achAccountList.length) {
      setAccountSequence(achAccountList[0]?.accountSequence || "");
    }

    if (billMyAccountData.length) {
      if (
        firstBillMyAccount?.isCard === "Y" &&
        isCardEnabled &&
        currentTab !== "ach" &&
        currentTab !== "bill-my-account" &&
        isNaN(parseInt(currentAccNumber))
      ) {
        const billMyAccountLast4 = last4(firstBillMyAccount?.cardNumber);
        const index = creditCardsList.findIndex(
          (data) => last4(data?.cardNumber) === billMyAccountLast4
        );
        if (index > -1 && document.getElementById(index)) {
          setCardBrandName(creditCardsList[index]?.cardBrand || "");
        }
        setCurrentTab("card");
      } else if (
        firstBillMyAccount?.isAccount === "Y" &&
        isACHEnabled &&
        currentTab !== "card" &&
        currentTab !== "bill-my-account" &&
        isNaN(parseInt(currentCardNumber))
      ) {
        setCurrentTab("ach");
        const billMyAccountLast4 = last4(firstBillMyAccount?.cardNumber);
        const index = achAccountList.findIndex(
          (data) => last4(data?.accountNumber) === billMyAccountLast4
        );
        if (index > -1 && document.getElementById(index)) {
          // kept for compatibility; selection is tracked in React state.
        }
      }

      if (
        currentCardNumber >= 0 &&
        document.getElementById(currentCardNumber) &&
        currentTab === "card"
      ) {
        document.getElementById(currentCardNumber).checked = "true";
      }
      if (
        currentAccNumber >= 0 &&
        document.getElementById(currentAccNumber) &&
        currentTab === "ach"
      ) {
        document.getElementById(currentAccNumber).checked = "true";
      }
    }

    if (last4(firstBillMyAccount?.cardNumber).length === 0 && currentTab == "") {
      if (isCardEnabled) {
        setCurrentTab("card");
      } else if (isACHEnabled) {
        setCurrentTab("ach");
      } else {
        setCurrentTab("bill-my-account");
      }
    }

    if (currentTab === "card" && !isCardEnabled) {
      setCurrentTab(isACHEnabled ? "ach" : "bill-my-account");
      setCurrentCardNumber(null);
      setCardSequence(null);
      setAddNewCartData(null);
      setErrorMsg("");
    }

    if (currentTab === "ach" && !isACHEnabled) {
      setCurrentTab(isCardEnabled ? "card" : "bill-my-account");
      setCurrentAccNumber(null);
      setAddAchSeq(null);
      setAddNewACHAccountData(null);
      setErrorMsg("");
    }

    // Auto-select the only available saved card so user does not need to click it.
    if (
      creditCardsList.length === 1 &&
      isCardEnabled &&
      (currentTab === "" || currentTab === "card") &&
      currentCardNumber === null &&
      !addNewCartData
    ) {
      const onlyCard = creditCardsList[0];
      setCurrentTab("card");
      setErrorMsg("");
      setStripeCustomerId(safeString(onlyCard?.stripeCustomerId));
      setCardSequence(onlyCard?.cardSequence || "");
      setAddNewCartData(onlyCard);
      setCurrentCardNumber(0);
      setCardBrandName(onlyCard?.cardBrand || "");
    }
  }, [
    creditCardsList,
    achAccountList,
    billMyAccountData,
    stripeCustomerId,
    setCurrentTab,
    currentAccNumber,
    currentCardNumber,
    currentTab,
    isCardEnabled,
    isACHEnabled,
    addNewCartData,
    firstBillMyAccount?.cardNumber,
    firstBillMyAccount?.isAccount,
    firstBillMyAccount?.isCard,
    firstBillMyAccount?.stripeCustomerId,
  ]);

  const changePaymentTab = (tabName) => {
    if (document.getElementById(currentAccNumber)) {
      document.getElementById(currentAccNumber).checked = "false";
    }
    if (document.getElementById(currentCardNumber)) {
      document.getElementById(currentCardNumber).checked = "false";
    }
    if (tabName === "bill-my-account") {
      setErrorMsg("");
    }
    setCurrentAccNumber(null);
    setCurrentCardNumber(null);
    setCurrentTab(tabName);
    setAddNewCartData(null);
    setAddNewACHAccountData(null);
    setCardSequence(null);
    setAddAchSeq(null);
  };

  const getCurrentCardImage = (cardType) => {
    switch (cardType) {
      case "EA":
        return americanExpress;
      case "EC":
        return masterCard;
      case "EV":
        return VISA;
    }
  };

  const getCardExpiryDateFormatted = (date) => {
    const normalizedDate = safeString(date);
    if (normalizedDate.length > 1) {
      const year = normalizedDate.slice(-2);
      let month;
      if (normalizedDate.length === 3) {
        month = "0" + normalizedDate.slice(0, 1);
      }
      if (normalizedDate.length === 4) {
        month = normalizedDate.slice(0, 2);
      }

      return `${month}/${year}`;
    }
    return "-";
  };
  return (
    <>
      <div className="checkout-common-shadow-wrapper">
        <div className="checkout-sub-card-header">
          <h2 className="checkout-sub-header-title">
            2. {translationKey(currentFileRequired["PAYMENT_INFO_HEADER"])}
          </h2>
        </div>
        <div className="payment-information-wrapper">
          <p
            className="checkout-error-message"
            style={{ color: "red", marginTop: 0 }}
          >
            {errorMsg}
          </p>
          <div className="payment-tabs">
            {creditCardRules && creditCardRules.enabled ? (
              <div
                onClick={() => changePaymentTab("card")}
                className={`tab ${
                  currentTab == "card" ? "active-payment-tab" : ""
                }`}
              >
                <img
                  src={currentTab == "card" ? activeCard : inactiveCard}
                  alt="card"
                />
                <span
                  className={`payment-method-name ${
                    currentTab == "card" ? "active-payment-method" : ""
                  }`}
                >
                  {translationKey(currentFileRequired["CARD"])}
                </span>
              </div>
            ) : null}
            {achRules && achRules.enabled ? (
              <div
                onClick={() => changePaymentTab("ach")}
                className={`tab ${
                  currentTab == "ach" ? "active-payment-tab" : ""
                }`}
              >
                <img src={currentTab == "ach" ? ACHActive : ACH} alt="card" />
                <span
                  className={`payment-method-name ${
                    currentTab == "ach" ? "active-payment-method" : ""
                  }`}
                >
                  {translationKey(currentFileRequired["ACH"])}
                </span>
              </div>
            ) : null}
            <div
              onClick={() => changePaymentTab("bill-my-account")}
              className={`tab ${
                currentTab == "bill-my-account" ? "active-payment-tab" : ""
              }`}
            >
              <img
                src={
                  currentTab == "bill-my-account"
                    ? billMyAccountActive
                    : billMyAccount
                }
                alt="card"
              />
              <span
                className={`payment-method-name ${
                  currentTab == "bill-my-account" ? "active-payment-method" : ""
                }`}
              >
                {translationKey(currentFileRequired["BILL_MY_ACCOUNT"])}
              </span>
            </div>
          </div>
          <div className="payment-info-details">
            {currentTab == "card" &&
            creditCardRules &&
            creditCardRules.enabled ? (
              <div className="payment-card-details-section">
                <span className="payment-info-details-header">
                  {translationKey(currentFileRequired["YOUR_CARDS"])}
                </span>

                <fieldset className="card-list">
                  {creditCardsList.length && creditCardRules.displayed ? (
                    creditCardsList.map((cardData, cardIndex) => {
                      return (
                        <div
                          style={{ marginBottom: "10px" }}
                          key={cardIndex.toString()}
                          className="radio-item"
                        >
                          <input
                            type="radio"
                            id={cardIndex}
                            name="card-number"
                            value={cardData.cardSequence}
                            className="radio-btn-card"
                            checked={cardIndex === currentCardNumber}
                            onClick={() => {
                              setErrorMsg("");
                              setStripeCustomerId(
                                safeString(cardData?.stripeCustomerId)
                              );
                              setCardSequence(cardData?.cardSequence || "");
                              setAddNewCartData(cardData);
                              setCurrentCardNumber(cardIndex);
                              setCardBrandName(cardData?.cardBrand || "");
                              // document.getElementById(cardIndex).checked =
                              //   "true";
                            }}
                          />
                          <label className="card-info">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <img
                                src={getCurrentCardImage(cardData.cardBrand)}
                                alt="card-type"
                              />
                              <span
                                style={{
                                  marginLeft: "5px",
                                  fontWeight: "normal",
                                }}
                                className="card-number-type"
                              >
                                {translationKey(currentFileRequired["CARD"])}{" "}
                                <span style={{ color: "#4b4b4b" }}>••••</span>
                                {last4(cardData?.cardNumber)}
                              </span>
                            </div>

                            <span
                              style={{ letterSpacing: "0" }}
                              className="card-number-type"
                            >
                              {translationKey(currentFileRequired["EXPIRES"])}:{" "}
                              {getCardExpiryDateFormatted(cardData.cardExpiry)}
                            </span>
                          </label>
                        </div>
                      );
                    })
                  ) : (
                    <div className="card-empty-state">
                      {translationKey(currentFileRequired["NO_CARD_MESSAGE"])}
                      <br />
                      <br />
                      {translationKey(currentFileRequired["ADD_CARD_MESSAGE"])}
                    </div>
                  )}
                </fieldset>
                {canAddNewCard ? (
                  <button
                    className="sec-btn"
                    onClick={() => {
                      setOpenModal(true);
                    }}
                  >
                    {creditCardsList.length
                      ? translationKey(currentFileRequired["ADD_NEW_CARD"])
                      : translationKey(currentFileRequired["ADD_CARD"])}
                  </button>
                ) : null}
              </div>
            ) : currentTab == "ach" && achRules && achRules.enabled ? (
              <div className="payment-ach-details-section">
                <div className="bill-my-account-header-section">
                  {translationKey(currentFileRequired["ACH_PAYMENT_HEADER"])}
                </div>
                <fieldset className="card-list">
                  {achAccountList.length && achRules.displayed ? (
                    achAccountList.map((achAccount, cardIndex) => {
                      return (
                        <div
                          style={{ marginBottom: "10px" }}
                          key={cardIndex.toString()}
                          className="radio-item"
                        >
                          <input
                            type="radio"
                            id={cardIndex}
                            name="card-number-ach"
                            value={achAccount.accountSequence}
                            checked={cardIndex === currentAccNumber}
                            className="radio-btn-card"
                            onClick={() => {
                              setErrorMsg("");
                              setAccountSequence(achAccount.accountSequence);
                              setCurrentAccNumber(cardIndex);
                              setAddNewACHAccountData(achAccount);
                              setAddAchSeq(achAccount.accountSequence);
                              // document.getElementById(cardIndex).checked =
                              //   "true";
                            }}
                          />
                          <label className="card-info">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <span style={{ fontWeight: "400" }}>
                                {achAccount.accountType} Account
                              </span>
                              <span
                                style={{
                                  marginLeft: "5px",
                                  fontWeight: "normal",
                                }}
                                className="card-number-type"
                              >
                                <span style={{ color: "#4b4b4b" }}>••••</span>
                                {last4(achAccount?.accountNumber)}
                              </span>
                            </div>

                            {/* <span
                              style={{ letterSpacing: "0" }}
                              className="card-number-type"
                            >
                              Expires:{" "}
                              {getCardExpiryDateFormatted(cardData.cardExpiry)}
                            </span> */}
                          </label>
                        </div>
                      );
                    })
                  ) : (
                    <div className="card-empty-state">
                      {translationKey(currentFileRequired["NO_ACH_MESSAGE"])}
                      <br />
                      <br />
                      {translationKey(currentFileRequired["ADD_ACH_MESSAGE"])}
                    </div>
                  )}
                </fieldset>
                {canAddNewACH ? (
                  <button
                    className="sec-btn"
                    onClick={() => {
                      setOpenModal(true);
                    }}
                  >
                    {creditCardsList.length
                      ? translationKey(currentFileRequired["ADD_NEW_ACH"])
                      : translationKey(currentFileRequired["ADD_ACH"])}
                  </button>
                ) : null}
              </div>
            ) : currentTab == "bill-my-account" ? (
              <div className="payment-bill-details-section">
                {billMyAccountData.length > 0 ? (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <input
                        type="radio"
                        id="bill-my-account"
                        name="bill-my-account"
                        checked
                        className="radio-btn-card"
                      />
                      <label
                        className="bill-my-account-radio"
                        htmlFor="bill-my-account"
                      >
                        {translationKey(currentFileRequired["BILL_MY_ACCOUNT"])}
                      </label>
                    </div>
                    <div className="bill-my-account-header-section">
                      {translationKey(currentFileRequired["PAYMENT_TERMS"])}
                    </div>
                    <div className="bill-my-account-details">
                      {firstBillMyAccount?.terms || ""}
                    </div>
                    {hasDefaultPaymentMethod ? (
                      <div className="bill-my-account-header-section">
                        {translationKey(
                          currentFileRequired["DEFAULT_PAYMENT_METHOD"]
                        )}
                      </div>
                    ) : null}
                    {hasDefaultPaymentMethod ? (
                      <label className="payment-card-info">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {firstBillMyAccount?.cardBrand === "EH" ? null : (
                            <img
                              src={getCurrentCardImage(
                                firstBillMyAccount?.cardBrand
                              )}
                              alt="card-type"
                            />
                          )}{" "}
                          <span
                            style={{
                              marginLeft: "5px",
                              fontWeight: "normal",
                              letterSpacing: "1px",
                            }}
                          >
                            {firstBillMyAccount?.isCard === "Y"
                              ? "Card "
                              : `${firstBillMyAccount?.accountType || ""} Account`}{" "}
                            <span style={{ color: "#4b4b4b" }}>••••</span>
                            {last4(firstBillMyAccount?.cardNumber)}
                          </span>
                        </div>

                        {firstBillMyAccount?.isCard === "Y" ? (
                          <span style={{ letterSpacing: "0" }}>
                            {translationKey(currentFileRequired["EXPIRES"])}:{" "}
                            {getCardExpiryDateFormatted(
                              firstBillMyAccount?.cardExpiry
                            )}
                          </span>
                        ) : null}
                      </label>
                    ) : null}
                    <div className="bill-my-account-header-section">
                      {translationKey(currentFileRequired["BILLING_ADDRESS"])}
                    </div>
                    <div
                      style={{ marginBottom: 0 }}
                      className="bill-my-account-details"
                    >
                      {firstBillMyAccount?.billingAddress1 || ""}
                    </div>
                    <div
                      style={{ marginBottom: 0 }}
                      className="bill-my-account-details"
                    >
                      {firstBillMyAccount?.billingAddress2 || ""}
                    </div>
                    <div
                      style={{ marginBottom: 0 }}
                      className="bill-my-account-details"
                    >
                      {firstBillMyAccount?.billingAddress3 || ""}
                    </div>
                    <div
                      style={{ marginBottom: 0 }}
                      className="bill-my-account-details"
                    >
                      {firstBillMyAccount?.billingAddress4 || ""}
                    </div>

                    <div
                      style={{ marginBottom: 0 }}
                      className="bill-my-account-details"
                    >
                      {[
                        firstBillMyAccount?.billingCity || "",
                        firstBillMyAccount?.billingState || "",
                        firstBillMyAccount?.billingZip || "",
                      ]
                        .join(" ")
                        .trim()}
                    </div>
                    <div
                      style={{ marginBottom: 0 }}
                      className="bill-my-account-details"
                    >
                      {firstBillMyAccount?.billingCountry || ""}
                    </div>
                  </div>
                ) : (
                  <div className="card-empty-state">
                    {translationKey(
                      currentFileRequired["NO_BILL_MY_ACCOUNT_MESSAGE"]
                    )}
                    <br />
                    <br />
                    {translationKey(
                      currentFileRequired["CUSTOMER_SERVICE_MESSAGE"]
                    )}
                  </div>
                )}
              </div>
            ) : null}
          </div>
          {openModal && (
            <AddCardModal
              stripeCustomerId={stripeCustomerId}
              closeModal={setOpenModal}
              setCreditCardsList={setCreditCardsList}
              currentTab={currentTab}
              setAchData={setAchData}
              setCurrentCardNumber={setCurrentCardNumber}
              setCurrentAccNumber={setCurrentAccNumber}
              creditCardsList={creditCardsList}
              achAccountList={achAccountList}
              setCardBrandName={setCardBrandName}
              setAddNewCartData={setAddNewCartData}
              setAddNewACHAccountData={setAddNewACHAccountData}
              setErrorMsgPlaceOrder={setErrorMsgPlaceOrder}
              setErrorMsg={setErrorMsg}
              canAddNewCard={canAddNewCard}
              canAddNewACH={canAddNewACH}
              currentFileRequired={currentFileRequired}
              translationKey={translationKey}
            />
          )}
        </div>
      </div>
    </>
  );
};
export default PaymentInformation;
